import React from "react";
import * as RB from "react-bootstrap";

function SpecifyModal({ show, onHide, data }) {
  return (
    <RB.Modal show={show} onHide={onHide} size="lg" centered>
      <RB.Modal.Header closeButton>
        <RB.Modal.Title>Specifications</RB.Modal.Title>
      </RB.Modal.Header>
      <RB.Modal.Body>
        {data && data.length > 0 ? (
          <RB.Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Property</th>
                <th>Specification</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.properties}</td>
                  <td>{item.specification}</td>
                </tr>
              ))}
            </tbody>
          </RB.Table>
        ) : (
          <p>No specifications available</p>
        )}
      </RB.Modal.Body>
    </RB.Modal>
  );
}

export default SpecifyModal;
